

module.exports = __webpack_require__.stylable.create(
    "ClearButton2006081505",
    {"classes":{"root":"ClearButton2006081505__root"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "ClearButton2006081505",
    null
);
